import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class ClientUtilitiesService {

  constructor(private httpClient: HttpClient) {
  }

  getAllDadConfigs(): Observable<any[]> {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/dad-config-names');
  }

  getSalesforceAccounts(uniqid: string): Observable<any[]> {
    let uniqidParam = '';
    if (uniqid) {
      uniqidParam = '?uniqid=' + uniqid;
    }
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/salesforce-accounts' + uniqidParam);
  }
}
